import { Box, Typography, SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';

interface HelpPopoverTextProps extends React.PropsWithChildren {
  className?: string;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
}

export const HelpPopoverText: React.FC<HelpPopoverTextProps> = ({
  children,
  className,
  style,
  sx,
}) => {
  const normalizedStyle =
    style && typeof style === 'object' && !Array.isArray(style) ? style : undefined;

  return (
    <Typography color='secondary' style={normalizedStyle} className={className} sx={sx}>
      {children}
    </Typography>
  );
};

interface HelpPopoverProps extends React.PropsWithChildren {
  title: string;
}

const HelpPopover: React.FC<HelpPopoverProps> = ({ children, title }) => {
  return (
    <Box paddingY={2} paddingX={1}>
      <Typography color='secondary' variant='p18Bold' mb={1}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default HelpPopover;
